import AiOverviewModal from './AiOverviewModal.component';

export default AiOverviewModal;
